import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as utils from '../../../common/utils';
import * as units from '../../../common/units';
import * as enums from '../../../common/enums';
import * as settings from '../../../common/settings';
import * as projMsgs from '../../../../../../src/app/msg/projMsgs';
import { mainMapMngr } from '../../../asp/MapMngr'
import { Point } from '../../../common/Point';
import { TempDrawingsPool, TempDrawingDataType, TempDrawingObject } from '../../../asp/temp-drawings';
import { AroService } from '../../aro.service'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { inputValidation } from '@core_n/common/input-validation';
import { Animations } from './../../../Animations';
import { userSettings } from '../../../common/settings';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { AppInjector } from '@core_n/common/inject';

@Component({
  selector: 'app-coords',
  templateUrl: './coords.component.html',
  styleUrls: ['./../../aro.component.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class CoordsComponent implements OnInit {
  @Output() change = new EventEmitter<string>();

  @Input() Geo: Point;
  @Input() isEditOnly: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() Required: boolean = true;

  @Input() public showUpdateButt: Array<boolean> = [];
  @Output() TriggerOutsideErrorAnim = new EventEmitter<boolean>();

 
  // Components Inputs
  public geometry: any = [0, 0];

  // read only stuff
  public location: string = "";

  // window propertie and forms
  public locForm: FormGroup;
  public isRorEbuttShow: boolean = true;
  //edit or back button
  public eORbButtonSwitch: boolean = true;
  public savedEditedPoint: Point;


  // all location and patterns and properties
  // Masks and Validators
  isLLDmm = false;
  isLLDms = false;
  isUTM = false;

  maskCustomPatterns = {
    'X': { pattern: new RegExp(`[\\d]`) },
    'Y': { pattern: new RegExp(`[\\d-]`) },
    '0': { pattern: new RegExp(`[\\d.]`) },
    '1': { pattern: new RegExp(`1`) },
    'N': { pattern: new RegExp(`[NnSs]`) },
    'E': { pattern: new RegExp(`[EeWw]`) },
    'Z': { pattern: new RegExp(`[C-H|J-N|P-X|c-h|j-n|p-x]`) },
  }
  maskSpecialCharacters = [units.DEGREE_CHAR, ` `, `'`, `"`];
  maskLatLLDmm: string;
  validLatLLDmm = [Validators.minLength(4)];
  maskLongLLDmm: string;
  validLongLLDmm = [Validators.minLength(4)];
  maskLatLLDms: string;
  validLatLLDms = [];
  maskLongLLDms: string;
  validLongLLDms = [];
  maskZoneUTM: string;
  validZoneUTM = [Validators.minLength(3)];
  maskEastingUTM: string;
  validEastingUTM = [Validators.minLength(6)];
  maskNorthingUTM: string;
  validNorthingUTM = [];

  // Location Units
  public locUnitsNum: enums.CoordinateType;
  public locUnits: string;

  // Track Dynamics
  // public geometry: any;

  // animations controls
  public state: boolean = false;
  tempMarker: TempDrawingObject = null;
  // location dmm lat
  public activeErrAnimLocDmmLat = false;
  public errTransLocDmmLat = false;
  // location dmm long
  public activeErrAnimLocDmmLong = false;
  public errTransLocDmmLong = false;
  // location dms lat
  public activeErrAnimLocDmsLat = false;
  public errTransLocDmsLat = false;
  // location dms long
  public activeErrAnimLocDmsLong = false;
  public errTransLocDmsLong = false;
  // location utm zone
  public activeErrAnimLocUtmZone = false;
  public errTransLocUtmZone = false;
  // location utm easting
  public activeErrAnimLocUtmEast = false;
  public errTransLocUtmEast = false;
  // location utm northing
  public activeErrAnimLocUtmNorth = false;
  public errTransLocUtmNorth = false;

  constructor(private aroService: AroService,
    private fb: FormBuilder) {
    // get user settings of location and units
    this.locUnitsNum = settings.userSettings.coordinatesType;
    this.locUnits = enums.CoordinateTypeTitle(this.locUnitsNum);

    // setup all masks to defaults
    this.maskLatLLDmm = `N 0000000${units.DEGREE_CHAR}||N 000000${units.DEGREE_CHAR}||N 00000${units.DEGREE_CHAR}||N 0000${units.DEGREE_CHAR}||N 000${units.DEGREE_CHAR}||N 00${units.DEGREE_CHAR}||N 0${units.DEGREE_CHAR}`;
    this.maskLongLLDmm = `E 00000000${units.DEGREE_CHAR}||E 0000000${units.DEGREE_CHAR}||E 000000${units.DEGREE_CHAR}||E 00000${units.DEGREE_CHAR}||E 0000${units.DEGREE_CHAR}||E 000${units.DEGREE_CHAR}||E 00${units.DEGREE_CHAR}||E 0${units.DEGREE_CHAR}`;
    this.maskLatLLDms = `N XX${units.DEGREE_CHAR}XX'XX0X"||N XX${units.DEGREE_CHAR}XX'XX"`;
    this.maskLongLLDms = `E XXX${units.DEGREE_CHAR}XX'XX0X"||E XX${units.DEGREE_CHAR}XX'XX0X"||E XXX${units.DEGREE_CHAR}XX'XX"||E XX${units.DEGREE_CHAR}XX'XX"`;
    this.maskZoneUTM = `XXZ`;
    this.maskEastingUTM = `X||XX||XXX||XXXX||XXXXX||XXXXXX`;
    this.maskNorthingUTM = `X||XX||XXX||XXXX||XXXXX||XXXXXX||XXXXXXX`;

    settings.userSettings.halfSecInter.subscribe(x => {
      this.animationPulse(x);
    });

    //setup refresh interval
    let self = this;
    setInterval(function () { self.refresh() }, 500);
  }

  ngOnInit(): void {
    if (this.Geo) {
      this.geometry = this.Geo;    
    }

    // if read only remove validations from form...
    // and hide switch button
    // also show read only on html and hide editable
    if (this.isReadOnly) {
      //setup form validators flags according to location type
      this.locForm = this.fb.group({
        latLLDmm: ['', undefined],
        longLLDmm: ['', undefined],
        latLLDms: ['', undefined],
        longLLDms: ['', undefined],
        zoneUTM: ['', undefined],
        eastingUTM: ['', undefined],
        northingUTM: ['', undefined],
      });
      // Hide Switch Button
      this.isRorEbuttShow = false;
      this.eORbButtonSwitch = true;
      return;
    }

    // if edit only make sure switch button is invisible
    // also show edits on html and hide read only
    if (this.isEditOnly) {
      this.isRorEbuttShow = false;
      this.eORbButtonSwitch = false;

      // setup on map symbol
      // this.createOrUpdateTempMarker(this.geometry);

      this.validLatLLDmm = [];
      this.validLongLLDmm = [];
      this.validLatLLDms = [];
      this.validLongLLDms = [];
      this.validZoneUTM = [];
      this.validEastingUTM = [];
      this.validNorthingUTM = [];
    }

    if (this.eORbButtonSwitch == false) {
      // setup on map symbol
      // this.createOrUpdateTempMarker(this.geometry);
      // setup Location type flags
      switch (settings.userSettings.coordinatesType) {
        case enums.CoordinateType.WGS84_DMM: {
          this.isLLDmm = true;
          break;
        }
        case enums.CoordinateType.WGS84_DMS: {
          this.isLLDms = true;
          break;
        }
        case enums.CoordinateType.UTM: {
          this.isUTM = true;
          break;
        }
      }
    }

    if (this.Required) {
      this.validLatLLDmm.push(Validators.required);
      this.validLongLLDmm.push(Validators.required);
      this.validLatLLDms.push(Validators.required);
      this.validLongLLDms.push(Validators.required);
      this.validZoneUTM.push(Validators.required);
      this.validEastingUTM.push(Validators.required);
      this.validNorthingUTM.push(Validators.required);
    }

    this.locForm = this.fb.group({
      latLLDmm: ['', this.isLLDmm ? this.validLatLLDmm : undefined],
      longLLDmm: ['', this.isLLDmm ? this.validLongLLDmm : undefined],
      latLLDms: ['', this.isLLDms ? this.validLatLLDms : undefined],
      longLLDms: ['', this.isLLDms ? this.validLongLLDms : undefined],
      zoneUTM: ['', this.isUTM ? this.validZoneUTM : undefined],
      eastingUTM: ['', this.isUTM ? this.validEastingUTM : undefined],
      northingUTM: ['', this.isUTM ? this.validNorthingUTM : undefined],
    });

    this.locationUpdate(true);
  }

  ngOnDestroy(): void {
    this.deleteTempMarker();
    mainMapMngr.activateDefaultToolForce();
  }

  protected refresh(): void {
    this.locationUpdate(false);
  }

  animationPulse(x: boolean) {
    // animation triggers and setters
    this.state = x;

    //Dmm Latitude
    if (this.activeErrAnimLocDmmLat) { this.errTransLocDmmLat = this.state; }
    else { this.errTransLocDmmLat = false; }

    //Dmm Longitude
    if (this.activeErrAnimLocDmmLong) { this.errTransLocDmmLong = this.state; }
    else { this.errTransLocDmmLong = false; }

    //Dms Latitude
    if (this.activeErrAnimLocDmsLat) { this.errTransLocDmsLat = this.state; }
    else { this.errTransLocDmsLat = false; }

    //Dms Longitude
    if (this.activeErrAnimLocDmsLong) { this.errTransLocDmsLong = this.state; }
    else { this.errTransLocDmsLong = false; }

    //Utm Zone
    if (this.activeErrAnimLocUtmZone) { this.errTransLocUtmZone = this.state; }
    else { this.errTransLocUtmZone = false; }

    //Utm Easting
    if (this.activeErrAnimLocUtmEast) { this.errTransLocUtmEast = this.state; }
    else { this.errTransLocUtmEast = false; }

    //Utm Norting
    if (this.activeErrAnimLocUtmNorth) { this.errTransLocUtmNorth = this.state; }
    else { this.errTransLocUtmNorth = false; }
  }

  // set coords
  public setCoords(geom: any) {
    this.geometry = geom;
    this.locationUpdate(true);
  }

  // Display Marker
  private createOrUpdateTempMarker(coord: Point) {
    if (this.isReadOnly) { return; }

    let geom = new NeWMI.Geometry.Point(coord);
    if (this.tempMarker)
      this.tempMarker.updateGeometry(geom);
    else
      this.tempMarker = TempDrawingsPool.getSelf().createTempDrawing(TempDrawingDataType.Symbol, geom, { value: 'm' });
  }

  private deleteTempMarker() {
    if (this.tempMarker) {
      TempDrawingsPool.getSelf().deleteObject(this.tempMarker);
      this.tempMarker = null;
    }
  }

  globalStrDisplayFix(str: string) {
    if (str == "" || str == "NaN" || str == undefined || str == null) { return "0"; }

    let max: number = 5;
    if (str.includes('.')) { max = 6; }
    if (str.length > max) { str = str.substring(0, max); }
    return str;
  }

  onSubmit() {
    if (this.tempMarker) {
      let coord = this.readFormLoc();
      if (coord)
        this.createOrUpdateTempMarker(coord);
    }
  }

  checkValueValid(str: string) {
    if ((str == undefined || str == null || str == "") && this.Required)
      return false;
    return true;
  }

  typingHandeling(e: InputEvent, type: string) {
    type = type.toLowerCase();
    switch (type) {
      case "dmmlat": {
        this.activeErrAnimLocDmmLat = false;
        let val = inputValidation.fixDmmLat(this.locForm.value.latLLDmm, e.data);
        this.locForm.controls.latLLDmm.setValue(val);
        break;
      }
      case "dmmlong": {
        this.activeErrAnimLocDmmLong = false;
        let val = inputValidation.fixDmmLong(this.locForm.value.longLLDmm, e.data);
        this.locForm.controls.longLLDmm.setValue(val);
        break;
      }
      case "dmslat": {
        this.activeErrAnimLocDmsLat = false;
        let val = inputValidation.fixDmsLat(this.locForm.value.latLLDms, e.data);
        this.locForm.controls.latLLDms.setValue(val);
        break;
      }
      case "dmslong": {
        this.activeErrAnimLocDmsLong = false;
        let val = inputValidation.fixDmsLong(this.locForm.value.longLLDms, e.data);
        this.locForm.controls.longLLDms.setValue(val);
        break;
      }
      case "utmzone": {
        this.activeErrAnimLocUtmZone = false;
        break;
      }
      case "utmeasing": {
        this.activeErrAnimLocUtmEast = false;
        break;
      }
      case "utmnorthing": {
        this.activeErrAnimLocUtmNorth = false;
        break;
      }
    }

    let loc = this.readFormLoc();
    if (loc && !this.eORbButtonSwitch) {
      this.createOrUpdateTempMarker(loc);
      this.change.emit("str");
    }

    this.TriggerOutsideErrorAnim.emit(false);
  }

  locationClick() {
    this.aroService.locationClick();
    this.locationUpdate(true);
  }

  locationUpdate(force: boolean) {
    this.location = utils.getCoordinatesString(this.geometry);
    if (!force) {
      if (this.locUnitsNum == settings.userSettings.coordinatesType)
        return;
    }

    this.savedEditedPoint = this.readFormLoc();

    this.locUnitsNum = settings.userSettings.coordinatesType;
    this.locUnits = enums.CoordinateTypeTitle(this.locUnitsNum);
    if (!this.eORbButtonSwitch) {
      switch (this.locUnitsNum) {
        case enums.CoordinateType.WGS84_DMM: {
          this.isLLDmm = true;
          this.isLLDms = false;
          this.isUTM = false;
          break;
        }
        case enums.CoordinateType.WGS84_DMS: {
          this.isLLDmm = false;
          this.isLLDms = true;
          this.isUTM = false;
          break;
        }
        case enums.CoordinateType.UTM: {
          this.isLLDmm = false;
          this.isLLDms = false;
          this.isUTM = true;
          break;
        }
      }
    }

    this.locForm = this.fb.group({
      latLLDmm: ['', this.isLLDmm ? this.validLatLLDmm : undefined],
      longLLDmm: ['', this.isLLDmm ? this.validLongLLDmm : undefined],
      latLLDms: ['', this.isLLDms ? this.validLatLLDms : undefined],
      longLLDms: ['', this.isLLDms ? this.validLongLLDms : undefined],
      zoneUTM: ['', this.isUTM ? this.validZoneUTM : undefined],
      eastingUTM: ['', this.isUTM ? this.validEastingUTM : undefined],
      northingUTM: ['', this.isUTM ? this.validNorthingUTM : undefined],
    });

    this.writeFormLoc(this.savedEditedPoint);
  }

  writeFormLoc(geo: Point = null) {
    let defaultLat = '';
    let defaultLong = '';
    let defaultZone = '';
    let defaultEasting = '';
    let defaultNorting = '';

    let strings = utils.getCoordinatesStrings(this.geometry, this.locUnitsNum);

    if (geo) {
      strings = utils.getCoordinatesStrings(geo, this.locUnitsNum);
    }

    if (strings.length == 0) {
      this.locForm.setValue({
        latLLDmm: defaultLat,
        longLLDmm: defaultLong,
        latLLDms: defaultLat,
        longLLDms: defaultLong,
        zoneUTM: defaultZone,
        eastingUTM: defaultEasting,
        northingUTM: defaultNorting,
      });
      return;
    }

    if (this.isLLDmm || this.isLLDms) {
      defaultLat = strings[0];
      defaultLong = strings[1];
    }
    else if (this.isUTM) {
      defaultZone = strings[0];
      defaultEasting = strings[1];
      defaultNorting = strings[2];
    }

    this.locForm.setValue({
      latLLDmm: defaultLat,
      longLLDmm: defaultLong,
      latLLDms: defaultLat,
      longLLDms: defaultLong,
      zoneUTM: defaultZone,
      eastingUTM: defaultEasting,
      northingUTM: defaultNorting,
    });
  }

  checkFormLoc(noTrigger?: boolean): boolean {
    // chaeck values valid...
    let err: boolean = false;

    //Check Dmm Values
    if (this.locUnitsNum == enums.CoordinateType.WGS84_DMM) {
      // Checks Dmm Lat
      let dmmLat: string = this.locForm.value.latLLDmm.toString();
      if (!this.checkValueValid(dmmLat) ||
        !this.locForm.controls.latLLDmm.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocDmmLat = true;
        }
      }

      // Checks Dmm Long
      let dmmLong: string = this.locForm.value.longLLDmm.toString();
      if (!this.checkValueValid(dmmLong) ||
        !this.locForm.controls.longLLDmm.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocDmmLong = true;
        }
      }
    }

    //Check Dms Values
    if (this.locUnitsNum == enums.CoordinateType.WGS84_DMS) {
      // Checks Dms Lat
      let dmsLat: string = this.locForm.value.latLLDms.toString();
      if (!this.checkValueValid(dmsLat) ||
        !this.locForm.controls.latLLDms.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocDmsLat = true;
        }
      }

      // Checks Dms Long
      let dmsLong: string = this.locForm.value.longLLDms.toString();
      if (!this.checkValueValid(dmsLong) ||
        !this.locForm.controls.longLLDms.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocDmsLong = true;
        }
      }
    }

    //Check Dms Values
    if (this.locUnitsNum == enums.CoordinateType.UTM) {
      // Checks Utm Zone
      let utmZone: string = this.locForm.value.zoneUTM.toString();
      if (!this.checkValueValid(utmZone) ||
        !this.locForm.controls.zoneUTM.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocUtmZone = true;
        }
      }

      // Checks Utm Easting
      let utmEast: string = this.locForm.value.eastingUTM.toString();
      if (!this.checkValueValid(utmEast) ||
        !this.locForm.controls.eastingUTM.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocUtmEast = true;
        }
      }

      // Checks Utm Northing
      let utmNorth: string = this.locForm.value.northingUTM.toString();
      if (!this.checkValueValid(utmNorth) ||
        !this.locForm.controls.northingUTM.valid) {
        err = true;
        if (!noTrigger) {
          this.activeErrAnimLocUtmNorth = true;
        }
      }
    }
    if (err)
      this.TriggerOutsideErrorAnim.emit(true);

    return err;
  }

  readFormLoc(): Point {
    let strings = [];

    if (this.locForm.valid == false) { return null; }

    if (this.isLLDmm) {
      if (this.locForm.value.latLLDmm == "") { return null }
      if (this.locForm.value.longLLDmm == "") { return null }
      strings = [this.locForm.value.latLLDmm, this.locForm.value.longLLDmm];
    }
    else if (this.isLLDms) {
      if (this.locForm.value.latLLDms == "") { return null }
      if (this.locForm.value.longLLDms == "") { return null }
      strings = [this.locForm.value.latLLDms, this.locForm.value.longLLDms];
    }
    else if (this.isUTM) {
      if (this.locForm.value.zoneUTM == "") { return null }
      if (this.locForm.value.eastingUTM == "") { return null }
      if (this.locForm.value.northingUTM == "") { return null }
      strings = [this.locForm.value.zoneUTM, this.locForm.value.eastingUTM, this.locForm.value.northingUTM];
    }

    if (strings.length > 0)
      return utils.getCoordinatesFromStrings(strings.map(string => string.trim()), this.locUnitsNum);

    return null;
  }

  // Map and OnMap events
  public setLocationClick() {
    mainMapMngr.activateMapEventsTool(this.onMapEvent.bind(this), [NeWMI.Map.Enums.EMapEvents.MouseDown]);
  }

  private onMapEvent(evt: NeWMI.Map.Events.MouseEvents) {
    let coord = { x: evt.mapPoint.x, y: evt.mapPoint.y };
    mainMapMngr.activateDefaultTool();
    // this.geometry = coord;
    // this.locationUpdate(true);
    this.writeFormLoc(coord);
    this.createOrUpdateTempMarker(coord);
    this.stopBlinkAnimation();
    this.change.emit("str");
    this.TriggerOutsideErrorAnim.emit(false);
  }

  stopBlinkAnimation() {
    this.activeErrAnimLocDmmLat = false;
    this.activeErrAnimLocDmmLong = false;
    this.activeErrAnimLocDmsLat = false;
    this.activeErrAnimLocDmsLong = false;
    this.activeErrAnimLocUtmZone = false;
    this.activeErrAnimLocUtmEast = false;
    this.activeErrAnimLocUtmNorth = false;
  }

  // true means read only
  // false means edit
  eORbClick() {
    this.eORbButtonSwitch = !this.eORbButtonSwitch;

    if (this.eORbButtonSwitch) {
      this.isLLDmm = false;
      this.isLLDms = false;
      this.isUTM = false;

      // this.createOrUpdateTempMarker(this.geometry);
      this.deleteTempMarker();
      this.showUpdateButt.pop();
    }
    else {
      this.showUpdateButt.push(true);
      // setup Location type flags
      switch (settings.userSettings.coordinatesType) {
        case enums.CoordinateType.WGS84_DMM: {
          this.isLLDmm = true;
          break;
        }
        case enums.CoordinateType.WGS84_DMS: {
          this.isLLDms = true;
          break;
        }
        case enums.CoordinateType.UTM: {
          this.isUTM = true;
          break;
        }
      }

      this.savedEditedPoint = this.readFormLoc();

      this.locForm = this.fb.group({
        latLLDmm: ['', this.isLLDmm ? this.validLatLLDmm : undefined],
        longLLDmm: ['', this.isLLDmm ? this.validLongLLDmm : undefined],
        latLLDms: ['', this.isLLDms ? this.validLatLLDms : undefined],
        longLLDms: ['', this.isLLDms ? this.validLongLLDms : undefined],
        zoneUTM: ['', this.isUTM ? this.validZoneUTM : undefined],
        eastingUTM: ['', this.isUTM ? this.validEastingUTM : undefined],
        northingUTM: ['', this.isUTM ? this.validNorthingUTM : undefined],
      });

      if (this.savedEditedPoint) {
        this.writeFormLoc(this.savedEditedPoint);
        this.createOrUpdateTempMarker(this.savedEditedPoint);
      }
      else {
        this.writeFormLoc();
        this.createOrUpdateTempMarker(this.geometry);
      }
    }
  }
}
